import { GuestBenefitDto } from "by/gamefactory/cityversetycoon/networking/data/responses/benefits/GuestBenefitDto";
import { BenefitType } from "./BenefitType";
import { ObjectFieldsChecker } from "by/gamefactory/tools/ObjectFieldsChecker";

export class BenefitItem {
    public readonly id: string;
    public readonly name: string;
    public readonly imageUrl: string;
    public readonly benefitId: BenefitType;
    public readonly endsIn: number;
    public readonly buildingPurchaseCouponDiscountPercentage: number;

    public constructor(dto: GuestBenefitDto) {
        this.validateDto(dto);
        this.id = dto.id;
        this.name = dto.name;
        this.imageUrl = dto.imageUrl;
        this.benefitId = dto.benefitId as BenefitType;
        this.endsIn = dto.endsIn;
        this.buildingPurchaseCouponDiscountPercentage = dto.buildingPurchaseCouponDiscountPercentage;
    }

    private validateDto(dto: GuestBenefitDto): void {
        ObjectFieldsChecker.throwIfInvalidFields(dto, [
            "id",
            "name",
            "imageUrl",
            "benefitId",
            "buildingPurchaseCouponDiscountPercentage"
        ]);
    }
}
